<template>
    <div class="seat-availability">
        <div @click="focus = true">
            <span class="pointer">{{localizeList.seatAvailability}}</span>
        </div>
        <div v-show="focus" class="bg-effect" @click="hide()"></div>

        <div v-show="focus" class="availability-checkbox-group-wrap">
            <div class="default">
                <div>
                    <p><span>{{localizeList.defaultYesFilter}}</span></p>
                    <p><span>{{localizeList.defaultYesRequestFilter}}</span></p>
                    <p><span>{{localizeList.defaultAllFilter}}</span></p>
                </div>
                <div class="availability-checkbox-group">
                    <div v-if="tourType === 'hotels'">
                        <icon class="mb-6" name="hotel" 
                              width="20px" height="20px" 
                              fill="var(--primary-color)" />

                        <div v-for="(item, key) in defaultHotelFilterForHotels"
                            :key="key"
                            class="filter-item mb-6">

                            <radio-btn :value="item.isChecked"
                                      @change="setDefaultFilter(item.value, 'hotelQuotaForHotels')">
                            </radio-btn>
                        </div>
                    </div>
                    <div v-else-if="tourType !== 'tickets'">
                        <icon class="mb-6" name="hotel" 
                              width="20px" height="20px" 
                              fill="var(--primary-color)" />

                        <div v-for="(item, key) in defaultHotelFilter"
                            :key="key"
                            class="filter-item mb-6">

                            <radio-btn :value="item.isChecked"
                                      @change="setDefaultFilter(item.value, 'hotelQuota')">
                            </radio-btn>
                        </div>
                    </div>
                    <div v-if="tourType === 'tickets'">
                        <icon class="mb-6" name="flight"
                              width="20px" height="20px"
                              fill="var(--primary-color)" />
                        <div v-for="(item, key) in defaultAirFilterForTickets"
                            :key="key"
                            class="filter-item mb-6">
                            <radio-btn :value="item.isChecked"
                                      @change="setDefaultFilter(item.value, 'aviaQuotaForTickets')">
                            </radio-btn>
                        </div>
                    </div>
                    <div v-else-if="tourType !== 'hotels'">
                        <icon class="mb-6" name="flight"
                              width="20px" height="20px"
                              fill="var(--primary-color)" />
                        <div v-for="(item, key) in defaultAirFilter"
                            :key="key"
                            class="filter-item mb-6">
                            <radio-btn :value="item.isChecked"
                                      @change="setDefaultFilter(item.value, 'aviaQuota')">
                            </radio-btn>
                        </div>
                    </div>
                    <div v-if="getSettings.IsShowBusTransferPlaces && tourType !== 'tickets' && tourType !== 'hotels'">
                        <icon class="mb-6" name="bus"
                              width="20px" height="20px"
                              fill="var(--primary-color)" />
                        <div v-for="(item, key) in defaultBusFilter"
                            :key="key"
                            class="filter-item mb-6">
                            <radio-btn :value="item.isChecked"
                                      @change="setDefaultFilter(item.value, 'busTransferQuota')">
                            </radio-btn>
                        </div>
                    </div>
                    <div v-if="getSettings.IsShowRwtTransferPlaces && tourType !== 'tickets' && tourType !== 'hotels'">
                        <icon  class="mb-6" name="train"
                              width="20px" height="20px"
                              fill="var(--primary-color)" />
                        <div v-for="(item, key) in defaultRailwayFilter"
                            :key="key"
                            class="filter-item mb-6">
                            <radio-btn :value="item.isChecked"
                                      @change="setDefaultFilter(item.value, 'trainTransferQuota')">
                            </radio-btn>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as mTypesTour from "@/stores/modules/tour/mutation_types";
import * as mTypesTickets from "@/stores/modules/tickets/mutation_types";
import * as mTypesHotels from "@/stores/modules/hotels/mutation_types";

export default {
  name: "availabilityFilter",
  mounted() {
    this.initialDefaultQuota();
  },
  data() {
    return {
        defaultAirFilter: [],
        defaultAirFilterForTickets: [],
        defaultHotelFilter: [],
        defaultHotelFilterForHotels: [],
        defaultBusFilter: [],
        defaultRailwayFilter: [],
        quotaItems: [
              {
                  isChecked: false,
                  value: 1
              },
              {
                  isChecked: false,
                  value: 5
              },
              {
                  isChecked: false,
                  value: 7
              }
          ],
          setDefaultFilterCounter: 0,
          focus: false
    };
  },
  props: {
    tourType: {
      type: String
    }
  },
  computed: {
      getSettings() {
          return this.$store.getters['getSettings']
      },
      getWindowSettings() {
          return window.settings;
    },
  },
  methods: {
      initialDefaultQuota() {
        const params = this.$route.params.searchParams;


        const quotaTypes = [
            { settingKey: 'DefaultAirFilter', filterKey: 'defaultAirFilter', mutationType: mTypesTour.M_SET_AVIA_QUOTA, tourType: 'tour', param: 'aviaQuota' },
            { settingKey: 'DefaultAirFilter', filterKey: 'defaultAirFilterForTickets', mutationType: mTypesTickets.M_SET_AVIA_QUOTA_FOR_TICKETS, tourType: 'tickets', param: 'aviaQuota' },
            { settingKey: 'DefaultHotelFilter', filterKey: 'defaultHotelFilter', mutationType: mTypesTour.M_SET_HOTEL_QUOTA, tourType: 'tour', param: 'hotelQuota' },
            { settingKey: 'DefaultHotelFilter', filterKey: 'defaultHotelFilterForHotels', mutationType: mTypesHotels.M_SET_HOTEL_QUOTA_FOR_HOTELS, tourType: 'hotels', param: 'hotelQuota' },
            { settingKey: 'DefaultBusFilter', filterKey: 'defaultBusFilter', mutationType: mTypesTour.M_SET_BUS_QUOTA, tourType: 'tour', param: 'busTransferQuota' },
            { settingKey: 'DefaultRailwayFilter', filterKey: 'defaultRailwayFilter', mutationType: mTypesTour.M_SET_RAILWAY_QUOTA, tourType: 'tour', param: 'trainTransferQuota' },
        ];

        quotaTypes.forEach(quota => {
          if (this.tourType !== quota.tourType) return
          this[quota.filterKey] = this.initializeFilter(quota.settingKey, quota.mutationType, quota.tourType, quota.param, params);
        });
      },
      initializeFilter(settingKey, mutationType, tourType, quotaParam, params) {
        const quotaItems = JSON.parse(JSON.stringify(this.quotaItems));

        if (params) {
          params = params.split("&");
          const quote = params.find(x => x.includes(quotaParam)).split("=")[1];

          this.$store.commit(tourType + "/" + mutationType, quote);
          return quotaItems.map(item => ({
            ...item,
            isChecked: quote == item.value,
          }));
        } else {
          this.$store.commit(tourType + "/" + mutationType, this.getSettings[settingKey]);
          return quotaItems.map(item => ({
            ...item,
            isChecked: this.getSettings[settingKey] == item.value,
          }));
        }
      },
      setDefaultFilter(key, typeTransport) {
            this.setDefaultFilterCounter++;

            if (typeTransport == "aviaQuota") {
                this.defaultAirFilter = this.defaultAirFilter.map((x) => {
                    x.isChecked = x.value === key;
                    return x
                });
                this.$store.commit("tour/" + mTypesTour.M_SET_AVIA_QUOTA, key)
            }

            if (typeTransport == "aviaQuotaForTickets") {
                this.defaultAirFilterForTickets = this.defaultAirFilterForTickets.map((x) => {
                    x.isChecked = x.value === key;
                    return x
                });
                this.$store.commit("tickets/" + mTypesTickets.M_SET_AVIA_QUOTA_FOR_TICKETS, key)
            }

            if (typeTransport == "hotelQuota") {
                this.defaultHotelFilter = this.defaultHotelFilter.map((x) => {
                    x.isChecked = x.value === key;
                    return x
                });
                this.$store.commit("tour/" + mTypesTour.M_SET_HOTEL_QUOTA, key)
            }

            if (typeTransport == "hotelQuotaForHotels") {
                this.defaultHotelFilterForHotels = this.defaultHotelFilterForHotels.map((x) => {
                    x.isChecked = x.value === key;
                    return x
                })
                this.$store.commit("hotels/" + mTypesHotels.M_SET_HOTEL_QUOTA_FOR_HOTELS, key)
            }

            if (typeTransport == "busTransferQuota") {
                this.defaultBusFilter = this.defaultBusFilter.map((x) => {
                    x.isChecked = x.value === key;
                    return x
                });
                this.$store.commit("tour/" + mTypesTour.M_SET_BUS_QUOTA, key)
            }

            if (typeTransport == "trainTransferQuota") {
                this.defaultRailwayFilter = this.defaultRailwayFilter.map((x) => {
                    x.isChecked = x.value === key;
                    return x
                });
                this.$store.commit("tour/" + mTypesTour.M_SET_RAILWAY_QUOTA, key)
            }
      },
      hide() {
          this.focus = false;
          if (this.setDefaultFilterCounter > 0) {
              this.setDefaultFilterCounter = 0
              this.$emit("blur")
          }
      }
  },
  watch: {
    tourType() {
      this.setDefaultFilterCounter = 0
      setTimeout(() => {
        this.initialDefaultQuota()
      }, 0);
    }
  }
};
</script>

<style scoped>
    .bg-effect {
        z-index: 100;
    }

    .seat-availability .availability-checkbox-group-wrap {
        text-align: left;
        display: flex;
        flex-direction: column;
        gap: 10px;
        font-size: 15px;
        position: absolute;
        top: 26px;
        left: -64px;
        z-index: 100;
        background-color: var(--white-color);
        padding: 12px 12px 0 12px;
        border-radius: 4px;
    }

    .seat-availability .availability-checkbox-group-wrap .default {
        display: flex;
        align-items: end;
        gap: 20px;
    }

    .seat-availability .availability-checkbox-group-wrap p {
        font-weight: normal;
        font-size: 15px;
        line-height: 18px;
        color: var(--dark-1-color);
        margin-bottom: 14px;
    }

    .seat-availability .availability-checkbox-group-wrap .availability-checkbox-group {
        display: grid;
        grid-template-columns: auto auto auto 1fr;
        grid-gap: 28px;
    }
</style>